import { createAction } from '@reduxjs/toolkit';
import { getFailurePayload, getSuccessPayload } from 'modules/utils';

import type { Advice } from 'types/Advice';
import type { Intervention, Policy } from '../types';
import * as actionTypes from '../actionTypes';

type AnswerWorksRequestData = {
  policies: Array<Policy>;
  checklistGroupId?: string;
  advices: Array<string>;
};

export const answerWorks = createAction(
  actionTypes.ANSWER_WORKS,
  (url: string, data: AnswerWorksRequestData, meta: Record<string, unknown> = {}) => {
    const { policies, ...rest } = data;

    return {
      payload: {
        request: {
          method: 'POST',
          url,
          data: rest,
        },
        policies,
      },
      meta,
    };
  }
);

export const answerWorksSuccess = createAction(actionTypes.ANSWER_WORKS_SUCCESS, getSuccessPayload<Intervention>);

export const answerWorksFailure = createAction(actionTypes.ANSWER_WORKS_FAILURE, getFailurePayload);

type AcceptAndPayWorksData = {
  advices: Array<Advice>;
  policies: Array<Policy>;
  checklistGroupId?: string;
};

export const acceptAndPayWorks = createAction(
  actionTypes.ACCEPT_AND_PAY_WORKS,
  (url: string, data: AcceptAndPayWorksData, meta: Record<string, unknown> = {}) => {
    const { advices, policies, checklistGroupId } = data;
    return {
      payload: {
        request: {
          method: 'POST',
          url,
          data: { advices, checklistGroupId },
        },
        policies,
      },
      meta,
    };
  }
);

export const acceptAndPayWorksSuccess = createAction(
  actionTypes.ACCEPT_AND_PAY_WORKS_SUCCESS,
  (redirectUrl: string, meta: Record<string, unknown> = {}) => ({
    payload: redirectUrl,
    meta,
  })
);

export const acceptAndPayWorksFailure = createAction(actionTypes.ACCEPT_AND_PAY_WORKS_FAILURE, getFailurePayload);
